const accountUsername = 'acgpartners'
const dataCenter = 'us19'
const id = 'b6687ebaf4'
const u = 'ccb9d0156ac3651b22ff82fde'

export const mailchimpConfig = {
	formActionUri: `//${accountUsername}.${dataCenter}.list-manage.com/subscribe/post-json?u=${u}&id=${id}&subscribe=subscribe&EMAIL=`
}